import { jsx as _jsx } from "react/jsx-runtime";
import { RichTextDialog } from '@client/components/richText/RichTextDialog';
import { INFO_PAGES } from '@client/domain/infoPageContent';
export const InfoPageDialog = ({ infoPageKey, open, onClose, }) => {
    const { title, contentHtml } = INFO_PAGES[infoPageKey];
    return (_jsx(RichTextDialog, { title: title, open: open, onClose: onClose, htmlString: contentHtml }));
};
